'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _slateReact = require('@gitbook/slate-react');

var _slate = require('@gitbook/slate');

var _TopicConfiguration = require('./TopicConfiguration');

var _TopicConfiguration2 = _interopRequireDefault(_TopicConfiguration);

var _TopicToolbar = require('./components/TopicToolbar');

var _TopicToolbar2 = _interopRequireDefault(_TopicToolbar);

var _ErrorBoundary = require('./components/ErrorBoundary');

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocalStorageKey = 'chatterslate:v1:content:' + window.location.pathname;
var DefaultValue = {
  document: {
    nodes: [{
      object: 'block',
      type: 'paragraph',
      nodes: []
    }]
  }
};

var TopicEditor = function (_React$Component) {
  _inherits(TopicEditor, _React$Component);

  function TopicEditor(props) {
    _classCallCheck(this, TopicEditor);

    var _this = _possibleConstructorReturn(this, (TopicEditor.__proto__ || Object.getPrototypeOf(TopicEditor)).call(this, props));

    Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(_ref) {
        var _value = _ref.value;

        var jsonContent = JSON.stringify(_value.toJSON());

        if (_this.state.debug) {
          console.log(jsonContent);
        }

        if (_value.document !== _this.state.value.document) {
          if (_this.props.onEditorChanged) {
            _this.props.onEditorChanged.call(LocalStorageKey);
          }
        }

        _this.setState({
          value: _value,
          menus: {}
        });
      }
    });
    Object.defineProperty(_this, 'handleClickUndo', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        event.preventDefault();
        var value = _this.state.value;

        var change = value.change().undo();
        _this.handleChange(change);
      }
    });
    Object.defineProperty(_this, 'handleClickRedo', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        event.preventDefault();
        var value = _this.state.value;

        var change = value.change().redo();
        _this.handleChange(change);
      }
    });
    Object.defineProperty(_this, 'handleMenuToggle', {
      enumerable: true,
      writable: true,
      value: function value(event, type) {
        event.preventDefault();
        var menus = {};
        if (!_this.state.menus[type]) {
          menus[type] = true;
        }
        _this.setState({ menus: menus });
      }
    });
    Object.defineProperty(_this, 'handleMobileToggle', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        event.preventDefault();
        _this.setState({ mobileView: !_this.state.mobileView });
      }
    });
    Object.defineProperty(_this, 'serializeJSON', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.state.value.toJSON();
      }
    });
    Object.defineProperty(_this, 'serializeHTML', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.editor.querySelector('[data-slate-editor]').innerHTML;
      }
    });
    Object.defineProperty(_this, 'clearStorage', {
      enumerable: true,
      writable: true,
      value: function value() {
        console.warn('Deprecated! No longer trusting localStorage.');
      }
    });


    _this.state = {
      mobileView: false,
      value: _slate.Value.fromJSON(props.initialValue || DefaultValue),
      menus: {},
      debug: false
    };
    return _this;
  }

  /**
   * Load a value into the editor, for example when clearing changes
   *
   * @param {object} value - parsed into a SlateJS {Value}
   * @return {Promise} - fired after the editor has finished setting this value
   */


  _createClass(TopicEditor, [{
    key: 'setValue',
    value: function setValue(value) {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.setState({ value: _slate.Value.fromJSON(value) }, function () {
          resolve();
        });
      });
    }

    /**
     * On change, save the new `value`, and hide the color menu
     *
     * @param {Change} change
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          title = _props.title,
          onError = _props.onError,
          placeholder = _props.placeholder,
          className = _props.className;
      var _state = this.state,
          menus = _state.menus,
          mobileView = _state.mobileView,
          value = _state.value;

      return _react2.default.createElement(
        _ErrorBoundary2.default,
        { onError: onError },
        _react2.default.createElement(
          'div',
          { className: 'chatterslate ' + (mobileView ? 'chatterslate_mobile' : '') },
          _react2.default.createElement(_TopicToolbar2.default, {
            menus: menus,
            mobileView: mobileView,
            value: value,
            onChange: this.handleChange,
            onMenuToggle: this.handleMenuToggle,
            onMobileToggle: this.handleMobileToggle,
            onClickUndo: this.handleClickUndo,
            onClickRedo: this.handleClickRedo
          }),
          title,
          _react2.default.createElement(
            'div',
            { className: 'editor', ref: function ref(editor) {
                _this3.editor = editor;
              } },
            _react2.default.createElement(_slateReact.Editor, {
              placeholder: placeholder,
              className: className,
              value: value,
              onChange: this.handleChange,
              plugins: _TopicConfiguration2.default.plugins,
              schema: _TopicConfiguration2.default.schema,
              autoFocus: true,
              spellCheck: true
            })
          )
        )
      );
    }

    // Public: Export JSON!


    // Public: Export HTML from what the editor renders.
    // Avoid using slate-html-serializer for now, but may need to soon.


    // Deprecated! Public: Reset local storage, usually after the editor has saved via the DB

  }]);

  return TopicEditor;
}(_react2.default.Component);

Object.defineProperty(TopicEditor, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    initialValue: _propTypes2.default.object,
    placeholder: _propTypes2.default.string,
    className: _propTypes2.default.string,
    title: _propTypes2.default.element,
    onError: _propTypes2.default.func,
    onEditorChanged: _propTypes2.default.func
  }
});
Object.defineProperty(TopicEditor, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    placeholder: 'Teach a topic...'
  }
});
exports.TopicEditor = TopicEditor;